import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'

const List =()=>{
const param = useParams()
    const [list,setList]= useState([])
    const Fetchlist = ()=>{
        fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${param.strCategory}`)
        .then((Response)=> Response.json())
        .then((data)=>{setList(data.meals)})
    }
    useEffect(()=>{
        Fetchlist();
    })
    
    return (
        <>

<section class="menu section bd-container" id="menu">
                <span class="section-subtitle">Special</span>
                <h2 class="section-title">Menu of the week</h2>

                <div class="menu__container bd-grid">

                {list && list.length>0 && list.map((value,index)=>(
               <div class="menu__content">
               <img src={value.strMealThumb} alt="" class="menu__img"/>
               <h3 class="menu__name">{value.strMeal}</h3>
               <span class="menu__detail">Serves 5 | Prep Time 20Mins</span>
               <span class="menu__preci">$22.00</span>
               <Link to={value.idMeal} class="button menu__button"><i class='bx bx-right-arrow-alt'></i></Link>
           </div>
            
            ))}


                </div>
            </section>





           
        </>
    )
}
export default List;
